
import { ApiModule } from '@api/src/ApiModule'

export class Router extends ApiModule {
  constructor(props) {
    super(props)

    const isIgnition = this.isIgnition()
    const enableLoanOptionsAmbitionCloud = this.enableLoanOptionsAmbitionCloud()

    // Status URL's from ApplicationsTableComponent.vue:1083
    // '',
    // 'stage/application',
    // 'stage/conditioning',
    // 'stage/loan-details',
    // 'stage/loan-submission',
    // 'stage/asset-and-seller',
    // 'stage/asset-and-seller',
    // 'stage/loan-options',
    // 'stage/loan-options',
    // 'stage/loan-summary',
    // 'stage/loan-summary',
    // 'stage/send-and-settle',
    // 'stage/send-and-settle',
    // 'stage/send-and-settle',
    // 'stage/send-and-settle',
    // 'stage/send-and-settle'

    /**
     * Application Statuses:
     *
     * @TODO: Move this to store, fetch statuses from server
     *
     * [cardViewLabel] (NOT IMPLEMENTED YET)
     *    Alternative label to show on card view page.
     *
     * [cardViewMappings]
     *    Maps applications with other statuses to this status column on the card view page.
     *    Useful for Ignition where we've reduced 15 columns down to 5 but need to show all apps.
     */
    this.statuses = [
      {
        label: 'New',
        stateName: 'new',
        route: 'stage/application',
        // cardViewLabel: 'Leads'
      },
      {
        label: 'Application Taken',
        stateName: 'appTaken',
        route: 'stage/conditioning'
      },
      {
        label: 'Documents Received',
        stateName: 'documentsReceived',
        route: 'stage/loan-details'
      },
      {
        label: 'Submitted to Lender',
        stateName: 'submittedToLender',
        route: 'stage/loan-submission',
        cardViewMappings: isIgnition ? [
          'Documents Received'
        ] : []
      },
      {
        label: 'Conditionally Approved',
        stateName: 'conditionallyApproved',
        route: 'stage/asset-and-seller',
        cardViewMappings: isIgnition ? [
          'Invoice Requested',
          'Invoice Returned',
          'Loan Package Sent',
          'Loan Package Confirmed',
          'Loan Resubmitted',
          'Loan Reapproved',
          'Contracts Sent',
          'In for Settlement'
        ] : []
      },
      {
        label: 'Invoice Requested',
        stateName: 'invoiceRequested',
        route: isIgnition ? 'stage/loan-summary' : 'stage/asset-and-seller'
      },
      {
        label: 'Invoice Returned',
        stateName: 'invoiceReturned',
        route: isIgnition ? (enableLoanOptionsAmbitionCloud ? 'stage/loan-options' : 'stage/loan-summary') : 'stage/loan-options'
      },
      {
        label: 'Loan Package Sent',
        stateName: 'optionsSent',
        route: isIgnition ? (enableLoanOptionsAmbitionCloud ? 'stage/loan-options' : 'stage/loan-summary') : 'stage/loan-options'
      },
      {
        label: 'Loan Package Received',
        stateName: 'optionsReceived',
        route: isIgnition ? 'stage/loan-summary' : 'stage/loan-summary',
      },
      {
        label: 'Loan Re-Submitted',
        stateName: 'loanSubmitted',
        route: isIgnition ? 'stage/loan-summary' : 'stage/loan-summary'
      },
      {
        label: 'Loan Re-Approved',
        stateName: 'loanApproved',
        route: isIgnition ? 'stage/loan-summary' : 'stage/send-and-settle'
      },
      {
        label: 'Contracts Sent',
        stateName: 'contractSent',
        route: isIgnition ? 'stage/loan-summary' : 'stage/send-and-settle'
      },
      {
        label: 'In for Settlement',
        stateName: 'contractReceived',
        route: isIgnition ? 'stage/loan-summary' : 'stage/send-and-settle'
      },
      {
        label: 'Settled',
        stateName: 'settled',
        route: isIgnition ? 'stage/loan-summary' : 'stage/send-and-settle'
      },
      {
        label: 'Completed',
        stateName: 'completed',
        route: isIgnition ? 'stage/loan-summary' : 'stage/send-and-settle'
      },
    ]
  }

  findRouteByStatus(statusName, applicationId) {
    const status = this.statuses.find((e) => e.label === statusName)
    return status && applicationId ? `/admin/applications/${applicationId}/${status.route}` : false
  }

  cardViewMappings() {
    const mapping = {}
    this.statuses.forEach((e) => {
      if (e.cardViewMappings) mapping[e.label] = e.cardViewMappings
    })
    return mapping
  }
}
